import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import { getApi } from "../apiPath";
import { axiosClient, queryClient } from "../clients";
import { useGetAllFacultyAcademicGroups } from "../faculties";
import type { IPickDelete } from "../types";

import type { IAcademicGroups } from "./routeType";
import { useGetAllAcademicGroup } from "./getAll";

const { getPath } = getApi("academicGroups.delete");

type IExtractedRouteType = IAcademicGroups["academicGroupSingleDelete"];

export type IDeleteAcademicGroup = IPickDelete<IExtractedRouteType>;

const deleteAcademicGroup: MutationFunction<
  IDeleteAcademicGroup["response"],
  IDeleteAcademicGroup["variables"]
> = ({ academicGroupId }) => {
  return axiosClient.delete(getPath({ academicGroupId }));
};

export const useDeleteAcademicGroup = createMutation({
  mutationFn: deleteAcademicGroup,
  onSuccess: (_) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllFacultyAcademicGroups.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetAllAcademicGroup.getKey(),
    });
  },
});
